export const listSetupIntents = `
   query listSetupIntents($filter: SetupIntentsFilterInput, $limit: Int, $nextToken: String) {
       listSetupIntents(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              clientSecret
              created
              customerId
              description
              lastSetupError
              paymentMethod
              paymentMethodTypes
              status
              usage
           }
           nextToken
       }
   }
`;

export const getSetupIntent = `
   query getSetupIntent($id:ID!) {
       getSetupIntent(id:$id) {
              id
              clientSecret
              created
              customerId
              description
              lastSetupError
              paymentMethod
              paymentMethodTypes
              status
              usage
       }
}`;
